export enum InvitationStatus {
  OPEN = 0,
  ACCEPTED = 1,
  REJECTED = 2,
  CANCELED = 3,
}

export enum ChatType {
  Global,
  Family,
}

export enum Gender {
  MALE = 0,
  FEMALE = 1,
}

export type InventoryType = "Items" | "NFTs" | "All";

export enum ItemCategory {
  CASH = 0,
  BULLET = 1,
  HEALTH = 2,
  SHOPITEM = 3,
  BUSINESS = 4,
  BODYGUARD = 5,
  HELPER_CREDIT = 6,
  CAR = 7,
  WRAPPED_NFT = 8,
  KEY = 9,
  MAFIA_TOKEN = 10,
  OGNFT = 11,
  NOTI_CREDIT = 12,

  LANDSLOT = 13,
  BUSINESS_EXTRA = 14,

  CAR_ITEM = 15,
  FBI_ASSETS = 16,

  PERK_BOX = 17,

  CRIME_SUCCESS = 18,
  NICK_CAR_SUCCESS = 19,
  BOOZE_SUCCESS = 20,
  NARCOTICS_SUCCESS = 21,
  KILL_SKILL_SUCCESS = 22,
  BUST_OUT_SUCCESS = 23,
  CRIME_COOLDOWN = 24,
  NICK_CAR_COOLDOWN = 25,
  BOOZE_COOLDOWN = 26,
  NARCOTICS_COOLDOWN = 27,
  KILL_SKILL_COOLDOWN = 28,
  TRAVEL_COOLDOWN = 29,
  BULLET_BUY_COOLDOWN = 30,
  HEALTH_BUY_COOLDOWN = 31,
  BUST_OUT_COOLDOWN = 32,
  MAP_YIELD_BOOS = 33,
  RACE_XP_BOOST = 34,
  KILL_SKILL_XP_BOOST = 35,
  BUST_OUT_XP_BOOST = 36,
  SALES_PRICE_NARCOTICS_BOOST = 37,
  SALES_PRICE_BOOZE_BOOST = 38,
  WORTH_BOOST = 39,
  REWARDS_BOOST = 40,
  PURCHASE_BOOST = 41,
  NO_JAIL_BOOST = 42,
  FREE_TRAVEL_BOOST = 43,
  BANK_FEE_BOOST = 44,
  CREDIT_COST_BOOST = 45,
  CONVERSION_RATE_BOOST = 46,
  CREDIT_SPEND_BOOST = 47,

  BODYGUARD_JOHNNY = 48,
  BODYGUARD_JIM = 49,
  BODYGUARD_SAM = 50,
  BODYGUARD_FRANK = 51,

  SUBSCRIPTION_ITEM = 52,
  GI_CREDIT = 53,

  MYSTERY_BOX = 54,

  BOOZE_PACK = 55,
  NARCS_PACK = 56,

  FOUNDER_TABLE_SHARE = 57
}

export enum AnimationStatus {
  Stopped = 0,
  SpeedUp = 1,
  Playing = 2,
  SpeedDown = 3,
}

export enum FamilyRole {
  Don = 0,
  Consigliere = 1,
  Capodecina = 2,
  Capo1 = 3,
  Capo2 = 4,
  Capo3 = 5,
  Capo4 = 6,
  Capo5 = 7,
  Successor = 8,
  Member = 9,
}

export enum ChainType {
  BNB = "BNB",
  PLS = "PLS",
}

export enum MarketSSEEventHeader {
  NewListing = "NewListing",
  ItemPurchased = "ItemPurchased",
  NewBid = "NewBid",
  CancelListing = "CancelListing",
}

export enum NotificationType {
  FamilyInvitation = 0,
  OTCRequest = 5,
  JailBustedEvent = 6,
  JailBuyOutEvent = 7,
}

export enum DaoProposalStatus {
  Pending = 0,
  Opened = 1,
  Closed = 2,
  Canceled = 3,
}

export enum SmugglingActionType {
  Buy,
  Sell,
}

export enum HelperBotType {
  CrimeBot = 0,
  GrandTheftAutoBot = 1,
  ShootingPracticeBot = 2,
  BoozeSmugglingBot = 3,
  NarcoticsSmugglingBot = 4,
  BulletDealerBot = 5,
  RaceXPBot = 6,
  BustOutXpBot = 7
}

// If you need to map the enum values to display strings, create a separate object:
export const HelperBotTypeLabels: Record<HelperBotType, string> = {
  [HelperBotType.CrimeBot]: "Crime bot",
  [HelperBotType.GrandTheftAutoBot]: "Grand theft auto bot",
  [HelperBotType.ShootingPracticeBot]: "Shooting practice bot",
  [HelperBotType.BoozeSmugglingBot]: "Booze smuggling bot",
  [HelperBotType.NarcoticsSmugglingBot]: "Narcotics smuggling bot",
  [HelperBotType.BulletDealerBot]: "Bullet dealer bot",
  [HelperBotType.RaceXPBot]: "Race XP bot",
  [HelperBotType.BustOutXpBot]: "Bust out XP bot",
};

export type RankType = "Low" | "Medium" | "High";

export enum XPType {
  RankXP = 0,
  KillXP = 1,
  BustXP = 2,
  RaceXP = 3,
}

export enum ProfilePlanType {
  Free = 0,
  Plus = 1,
  Unlimited = 2,
}

export enum CrimeLobbyStatus {
  Waiting = 0,
  Started = 1,
  Finished = 2,
  Cancelled = 3,
}

export enum DetectiveHireStatus {
  Pending,
  Success,
  Failed
}